var AT_Slider ={
  
    owlSlider : function(){
      
        jQuery(".featured-post-slider").length && jQuery(".featured-post-slider").owlCarousel({
            autoplay  : false
            ,dots     : true
            ,loop   : false
            ,items    : 1
          
        });
      
        if ( bcMsieVersion.MsieVersion() > 9 || bcMsieVersion.MsieVersion() == 0 ){
          jQuery(".lookbook-slider").length && jQuery(".lookbook-slider").owlCarousel({
              nav         : false
              ,dots       : true
              ,responsive :{
                  0:{
                      items:1
                  }
                  ,600:{
                      items:3
                  }
                  ,1000:{
                    items:5
                  }
              }

          });
        }
        else{
          jQuery(".lookbook-slider").length && jQuery(".lookbook-slider").owlCarousel({
              nav         : false
              ,dots       : true
              ,responsive :{
                  0:{
                      items:1
                  }
                  ,600:{
                      items:3
                  }
                  ,1000:{
                    items:4
                  }
              }

          });
        }
      
        jQuery(".related-items").length && jQuery(".related-items").on('initialize.owl.carousel initialized.owl.carousel change.owl.carousel changed.owl.carousel', function(e) {
            var current = e.relatedTarget.current()
            var items = $(this).find('.owl-stage').children()
            var add = e.type == 'changed' || e.type == 'initialized'

            items.eq(e.relatedTarget.normalize(current )).toggleClass('current', add)
        }).owlCarousel({
             nav     : true
            ,dots     : true
            ,items    : 4
            ,responsive : {
              0:{
                items: 1
              }
              ,480:{
                items: 2
              }
              ,768:{
                items: 3
              }
              ,1080:{
                items: 4
              }
            }
    });
      
        
    this.initThumbSlider(true);  
  }

    ,loadThumbByColor: function(color, elem) {
      for(var i=0; i < _all_options.length; i++) {
        if( _all_options[i].option1 != color ) {
          $($(elem)[i]).addClass('hidden'); 
        }
        else {
          $($(elem)[i]).removeClass('hidden');  
        }  
      }
      if(AT_Slider.thumbSlider) {
        AT_Slider.thumbSlider.destroySlider();
        AT_Slider.initThumbSlider(); 
      }  
    }

    ,initThumbSlider: function(init){
      if (window.innerWidth > 767) {
        if( !$('#gallery-image').length ) 
          return;
        var init = init || false;
        var containerW = parseInt($('.more-view-image').css('width'));
        var elem = $('#gallery-image');
        var mode = ( AT_Main.checkLayout()==1 )?'horizontal':'vertical'; 
        var slideW = ( AT_Main.checkLayout()==1 )?(containerW/4 - 15):(containerW - 30);
        AT_Slider.thumbSlider = elem.bxSlider({ 
            mode: mode,
            slideSelector: 'li:visible',
            slideWidth: slideW,
            minSlides: 4,
            maxSlides: 4,
            nextText: '<i class="fa fa-angle-down" title="Next"></i>',
            prevText: '<i class="fa fa-angle-up" title="Previous"></i>',
            hideControlOnEnd: false,
            infiniteLoop: false,
            pager: false,
            slideMargin: 15,
            onSliderLoad: function(){
              if(init) {

                if( 'undefined' !== typeof _op1_array){
                  setTimeout(function(){
                    AT_Slider.loadThumbByColor(_op1_array[0], '#gallery-image li');  
                  },500);
                }

              }
              if( AT_Main.checkLayout()==1 ) {
                var slideH = parseInt($('.more-view-image').css('height'));
                $('#product-image').css({
                  'padding-bottom': slideH + 'px'
                })
              }
              else {
                $('#product-image').css({
                  'padding-bottom': 0 + 'px'
                })  
              }        
            }
        });
        $(".pdp #product-image .more-view-image").css("visibility", "initial");
      }
      else{
        var swiperThumbs = new Swiper('.mobile-image.swiper', {
          direction: 'horizontal',
          loop: false,
          slidesPerView: 1,
          allowTouchMove: true,
          autoHeight: true,
          scrollbar: {
              el: ".swiper-scrollbar",
              draggable: true
          },
          on: {
              init: function () {
                  console.log('mobile swiper initialized');
              }
          }
        });
      }
    }

    ,initQsThumbSlider: function(){
      if( !$('#gallery-qs-image').length )
        return;
      var containerW = parseInt($('.product-thumb-slide').css('width'));
      var elem = $('#gallery-qs-image');
      var mode = ( AT_Main.checkLayout()==1 )?'horizontal':'vertical';
      var slideW = ( AT_Main.checkLayout()==1 )?(containerW/4 - 15):(containerW - 30);
      AT_Slider.thumbSlider2 = elem.bxSlider({
          mode: mode,
          slideWidth: slideW,
          minSlides: 4,
          maxSlides: 4,
          nextText: '<i class="fa fa-angle-down" title="Next"></i>',
          prevText: '<i class="fa fa-angle-up" title="Previous"></i>',
          hideControlOnEnd: false,
          infiniteLoop: false,
          pager: false,
          slideMargin: 15,
      });
    }
  
    ,init : function(){
      this.owlSlider();
    }
  
}

/* Check IE */
if(typeof bcMsieVersion == 'undefined'){
  var bcMsieVersion = {

    MsieVersion: function() {

      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");

      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer, return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
      else                 // If another browser, return 0
        {
        return 0;
      }
    }

    ,init : function(){
      this.MsieVersion();
    }
  }
}


jQuery(document).ready(function($) {
  
  AT_Slider.init();
  bcMsieVersion.init();

  /*Reload slider with new settings*/
  $(window).on('resize', function(){
    if(AT_Slider.thumbSlider) {
      AT_Slider.thumbSlider.destroySlider();
      AT_Slider.initThumbSlider(); 
    }
    if(AT_Slider.thumbSlider2) {
      AT_Slider.thumbSlider2.destroySlider();
      AT_Slider.initQsThumbSlider(); 
    }
    
  });
      
});